import React from "react";

export const InternalServerErrorPage = () => {
  return (
    <>
      <h1>Something Went Wrong!!!</h1>
    </>
  );
}
